(function workflowModuleDefinition() {

    'use strict';

    angular.module('Workflow', ['ui.router', 'Config', 'Entities', 'ClickOnce'])
        .config([
            'configProvider', '$stateProvider', 'loginProvider',
            function notificationConfig(config, $stateProvider, loginProvider) {

                $stateProvider.state('workflow-find', {
                    url: "/Workflow/List",
                    templateUrl: config.resourceUrl('/views/workflow/list.html'),
                    controller: 'WorkflowFindController',
                    authorize: true
                });

                $stateProvider.state('workflow-modify', {
                    url: "/Workflow/Modify/{id}",
                    templateUrl: config.resourceUrl('/views/workflow/modify.html'),
                    controller: 'WorkflowModifyController',
                    authorize: true
                });
            }
        ]);
})();